import { Routes, Route } from 'react-router-dom';
import ProtectedRoute from './ProtectedRoute';
import RouteErrorBoundary from './RouteErrorBoundary';
import GameRoute from './GameRoute';
import GameList from '../pages/game/GameList';
import GameSetup from '../pages/game/GameSetup';
import GameBoard from '../pages/game/GameBoard';

/* Auth */
import CreateAccountPage from '../auth/CreateAccountPage';
import LoginPage from '../auth/LoginPage';
import RegisterPage from '../auth/RegisterPage';
import RegisterNewOrgPage from '../auth/RegisterNewOrgPage';
import ForgotPasswordPage from '../auth/ForgotPasswordPage';
import ResetPasswordPage from '../auth/ResetPasswordPage';
import EmailVerificationPage from '../auth/EmailVerificationPage';
import VerificationSuccessPage from '../auth/VerificationSuccessPage';
import UnauthorizedPage from '../auth/UnauthorizedPage';
import CheckYourEmailPage from '../auth/CheckYourEmailPage';
import HomePage from '../pages/home/HomePage';
import AppsPage from '../pages/apps/AppsPage';
import ReportsPage from '../pages/reports/ReportsPage';

/* Orgs */
import OrgPage from '../pages/orgs/DataPage';
import OrgUpdatePage from '../pages/orgs/OrgUpdatePage';

/* App Pages */
import AdminPage from '../pages/AdminPage';
import SuperAdminPage from '../pages/SuperAdminPage';
import PrintManagerPage from '../pages/printManager/PrintManagerPage';
import DeviceDetail from '../pages/printManager/DeviceDetail';
import DevicesPage from '../pages/printManager/DevicesPage';
import PrinterGroupsTab from '../pages/printManager/PrinterGroupsTab';


import UserPage from '../pages/users/DataPage';
import UserUpdatePage from '../pages/users/UserUpdatePage';
import LP from '../pages/lp/MobileLandingPage';
import LandingPage from '../pages/lp/DataPage';
import MediaPage from '../pages/media/MediaLibraryPage';
import LandingPageUpdate from '../pages/lp/LandingPageBuilder';
import DesignPage from '../pages/cards/DataPage';
import DesignPageUpdate from '../pages/cards/CanvasDesigner';
import FieldTemplateList from '../pages/data/FieldTemplateList';
import AddTemplate from '../pages/data/AddTemplate';
import ViewTemplate from '../pages/data/ViewTemplate';
import EditFieldTemplate from '../pages/data/EditFieldTemplate';
import AddDataDoc from '../pages/datasets/AddDataDoc';
import ViewDataSet from '../pages/datasets/ViewDataSet';
import InviteAcceptPage from '../auth/InviteAcceptPage';
import AddOrganization from '../pages/orgs/AddOrganization';
// import PrintersList from '../pages/print/PrintersList';
import PrinterDetail from '../pages/print/PrinterDetail';
import ActionsList from "../pages/actions/ActionsList";
import DataSetActionsView from "../pages/actions/DataSetActionsView";
import DataSetActionsEdit from "../pages/actions/DataSetActionsEdit";
import AddAction from "../pages/actions/AddAction";
import EditAction from "../pages/actions/EditAction";
import GalleryDataSetsList from '../pages/gallery/GalleryDataSetsList';
import DisplayGallery from '../pages/gallery/DisplayGallery';
import GallerySetup from '../pages/gallery/GallerySetup';
import DataSetsList from "../pages/datasets/DataSetsList";
import DataDocList from "../pages/datasets/DataDocList";
import DataDocs from "../pages/production/DataDocs";
import AddDataSet from "../pages/datasets/AddDataSet";
import EditDataSet from "../pages/datasets/EditDataSet";
import DataSetActionsManage from "../pages/datasets/DataSetActionsManage";
import PartnerPortal from '../pages/partners/PartnerPortal';
import ResultPortalList from '../pages/results/ResultPortalList';
import ResultPortalSetup from '../pages/results/ResultPortalSetup';
import ResultPortalDisplay from '../pages/results/ResultPortalDisplay';
import ShareDisplay from '../pages/results/ShareDisplay';


export default function AppRoutes() {
    return (
        <Routes>

        {/* ---------- PUBLIC ---------- */}
        <Route path="/results/display/:token" element={<RouteErrorBoundary><ResultPortalDisplay /></RouteErrorBoundary>} />
        <Route path="/results/share/:token" element={<RouteErrorBoundary><ShareDisplay /></RouteErrorBoundary>} />
        <Route path="/share/:token" element={<RouteErrorBoundary><ShareDisplay /></RouteErrorBoundary>} />
        <Route path="/results/datasets" element={<RouteErrorBoundary><ProtectedRoute requiredOrgRoles={['org:admin', 'org:owner', 'superadmin']}><ResultPortalList /></ProtectedRoute></RouteErrorBoundary>} />
        <Route path="/results/setup/:id" element={<RouteErrorBoundary><ProtectedRoute requiredOrgRoles={['org:admin', 'org:owner', 'superadmin']}><ResultPortalSetup /></ProtectedRoute></RouteErrorBoundary>} />
        <Route path="/" element={<LoginPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/create-account" element={<CreateAccountPage />} />
        <Route path="/register" element={<RegisterPage />} />
        <Route path="/register/new" element={<RegisterNewOrgPage />} />
        <Route path="/forgot-password" element={<ForgotPasswordPage />} />
        <Route path="/reset-password/:token" element={<ResetPasswordPage />} />
        <Route path="/verify-email/:token" element={<EmailVerificationPage />} />
        <Route path="/verification-success" element={<VerificationSuccessPage />} />
        <Route path="/unauthorized" element={<UnauthorizedPage />} />
        <Route path="/check-your-email" element={<CheckYourEmailPage />}
        />
        {/* ---------- ORGS ---------- */}
        <Route
          path="/orgs"
          element={
            <RouteErrorBoundary>
              <ProtectedRoute>
                <OrgPage />
              </ProtectedRoute>
            </RouteErrorBoundary>
          }
        />
        <Route
          path="/orgs/add"
          element={
            <RouteErrorBoundary>
              <ProtectedRoute requiredGlobals={['org:admin', 'org:owner', 'superadmin']}>
                <OrgUpdatePage />
              </ProtectedRoute>
            </RouteErrorBoundary>
          }
        />
        <Route
          path="/orgs/:orgId"
          element={
            <RouteErrorBoundary>
              <ProtectedRoute requiredOrgRoles={['org:admin', 'org:owner', 'superadmin']}>
                <OrgUpdatePage />
              </ProtectedRoute>
            </RouteErrorBoundary>
          }
        />
        {/* ---------- ADMIN ---------- */}
        <Route
          path="/admin"
          element={
            <RouteErrorBoundary>
              <ProtectedRoute requiredGlobals={['org:admin', 'org:owner', 'superadmin']}>
                <AdminPage />
              </ProtectedRoute>
            </RouteErrorBoundary>
          }
        />
        <Route
          path="/superadmin"
          element={
            <RouteErrorBoundary>
              <ProtectedRoute requiredGlobals={['org:admin', 'org:owner', 'superadmin']}>
                <SuperAdminPage />
              </ProtectedRoute>
            </RouteErrorBoundary>
          }
        />
        {/* ---------- PRINT MANAGER ---------- */}
        <Route
          path="/printers"
          element={
            <RouteErrorBoundary>
              <ProtectedRoute requiredOrgRoles={['org:admin', 'org:owner', 'superadmin']}>
                <PrintManagerPage />
              </ProtectedRoute>
            </RouteErrorBoundary>
          }
        />
        <Route
          path="/printergroups"
          element={
            <RouteErrorBoundary>
              <ProtectedRoute requiredOrgRoles={['org:admin', 'org:owner', 'superadmin']}>
                <PrinterGroupsTab />
              </ProtectedRoute>
            </RouteErrorBoundary>
          }
        />

        <Route path="/lp/:landingPageId/:gameId/:clueNo" element={<LP />} />

        {/* ---------- LEGACY ROUTES ---------- */}
          <Route path="/lp/:landingPageId" element={<LP/>}/>
          <Route path="/lp/:landingPageId/:gameId/:clueNo" element={<LP />} />
          <Route path="/register/invite/:token" element={<RouteErrorBoundary><InviteAcceptPage /></RouteErrorBoundary>} />
          <Route path="/user-management" element={<RouteErrorBoundary><ProtectedRoute requiredRoles={['org:admin', 'org:owner', 'superadmin']}><UserPage /></ProtectedRoute></RouteErrorBoundary>}/>
          <Route path="/user-management/:id" element={<RouteErrorBoundary><ProtectedRoute requiredRoles={['org:admin', 'org:owner', 'superadmin']}><UserUpdatePage /></ProtectedRoute></RouteErrorBoundary>}/>
          <Route path="/superadmin" element={<RouteErrorBoundary><ProtectedRoute requiredRoles={['org:admin', 'org:owner', 'superadmin']}><SuperAdminPage /></ProtectedRoute></RouteErrorBoundary>}/>
          <Route path="/lpages" element={<RouteErrorBoundary><ProtectedRoute requiredRoles={['org:admin', 'org:owner', 'superadmin']}><LandingPage /></ProtectedRoute></RouteErrorBoundary>}/>
          <Route path="/lpages/edit/:id" element={<RouteErrorBoundary><ProtectedRoute requiredRoles={['org:admin', 'org:owner', 'superadmin']}><LandingPageUpdate /></ProtectedRoute></RouteErrorBoundary>}/>

          <Route path="/mediapage" element={<RouteErrorBoundary><ProtectedRoute requiredRoles={['org:admin', 'org:owner', 'superadmin']}><MediaPage /></ProtectedRoute></RouteErrorBoundary>}/>

          <Route path="/cards" element={<RouteErrorBoundary><ProtectedRoute requiredRoles={['org:admin', 'org:owner', 'superadmin']}><DesignPage /></ProtectedRoute></RouteErrorBoundary>}/>
          <Route path="/cards/:id" element={<RouteErrorBoundary><ProtectedRoute requiredRoles={['org:admin', 'org:owner', 'superadmin']}><DesignPageUpdate /></ProtectedRoute></RouteErrorBoundary>}/>
          <Route path="/templates/fieldtemplateList" element={<RouteErrorBoundary><ProtectedRoute requiredRoles={['org:admin', 'org:owner', 'superadmin']}><FieldTemplateList /></ProtectedRoute></RouteErrorBoundary>}/>
          <Route path="/templates/viewtemplate/:templateId" element={<RouteErrorBoundary><ProtectedRoute requiredRoles={['org:admin', 'org:owner', 'superadmin']}><ViewTemplate /></ProtectedRoute></RouteErrorBoundary>}/>
          <Route path="/templates/editfieldtemplate/:templateId" element={<RouteErrorBoundary><ProtectedRoute requiredRoles={['org:admin', 'org:owner', 'superadmin']}><EditFieldTemplate /></ProtectedRoute></RouteErrorBoundary>}/>
          <Route path="/templates/addtemplate" element={<RouteErrorBoundary><ProtectedRoute requiredRoles={['org:admin', 'org:owner', 'superadmin']}><AddTemplate /></ProtectedRoute></RouteErrorBoundary>}/>
          <Route path="/datasets" element={<RouteErrorBoundary><ProtectedRoute requiredRoles={['org:admin', 'org:owner', 'superadmin']}><DataSetsList /></ProtectedRoute></RouteErrorBoundary>} />
          <Route path="/datasets/datadoclist" element={<RouteErrorBoundary><ProtectedRoute requiredRoles={['org:admin', 'org:owner', 'superadmin']}><DataDocList /></ProtectedRoute></RouteErrorBoundary>} />
          <Route path="/production/data-records/:datasetId" element={<RouteErrorBoundary><ProtectedRoute requiredRoles={['org:admin', 'org:owner', 'superadmin']}><DataDocs /></ProtectedRoute></RouteErrorBoundary>} />
          <Route path="/datasets/add" element={<RouteErrorBoundary><ProtectedRoute requiredRoles={['org:admin', 'org:owner', 'superadmin']}><AddDataSet /></ProtectedRoute></RouteErrorBoundary>} />
          <Route path="/datasets/edit/:id" element={<RouteErrorBoundary><ProtectedRoute requiredRoles={['org:admin', 'org:owner', 'superadmin']}><EditDataSet /></ProtectedRoute></RouteErrorBoundary>} />
          <Route path="/datasets/actions/:datasetId" element={<RouteErrorBoundary><ProtectedRoute requiredRoles={['org:admin', 'org:owner', 'superadmin']}><DataSetActionsManage /></ProtectedRoute></RouteErrorBoundary>} />
          <Route path="/datasets/viewdataset/:datasetId" element={<RouteErrorBoundary><ProtectedRoute requiredRoles={['org:admin', 'org:owner', 'superadmin']}><ViewDataSet /></ProtectedRoute></RouteErrorBoundary>}/>
          <Route path="/datasets/editdataset/:datasetId" element={<RouteErrorBoundary><ProtectedRoute requiredRoles={['org:admin', 'org:owner', 'superadmin']}><EditDataSet  /></ProtectedRoute></RouteErrorBoundary>}/>
          <Route path="/datasets/adddatadoc/:datasetId" element={<RouteErrorBoundary><ProtectedRoute requiredRoles={['org:admin', 'org:owner', 'superadmin']}><AddDataDoc /></ProtectedRoute></RouteErrorBoundary>}/>
          <Route path="/devices/:deviceId" element={<RouteErrorBoundary><ProtectedRoute requiredOrgRoles={['org:admin', 'org:owner']}><DeviceDetail /></ProtectedRoute></RouteErrorBoundary>}/>
          <Route path="/devices" element={<RouteErrorBoundary><ProtectedRoute requiredOrgRoles={['org:admin', 'org:owner', 'superadmin']}><DevicesPage /></ProtectedRoute></RouteErrorBoundary>}/>
          <Route path="/printmanagerpage" element={<RouteErrorBoundary><ProtectedRoute requiredRoles={['org:admin', 'org:owner', 'superadmin']}><PrintManagerPage /></ProtectedRoute></RouteErrorBoundary>}/>
          <Route path="/homepage" element={<RouteErrorBoundary><ProtectedRoute requiredRoles={['org:admin', 'org:owner', 'org:user', 'superadmin']}><HomePage /></ProtectedRoute></RouteErrorBoundary>}/>
          <Route path="/apps" element={<RouteErrorBoundary><ProtectedRoute><AppsPage /></ProtectedRoute></RouteErrorBoundary>}/>
          <Route path="/reports" element={<RouteErrorBoundary><ProtectedRoute><ReportsPage /></ProtectedRoute></RouteErrorBoundary>}/>
          <Route path="/printerdetail/:pid" element={<RouteErrorBoundary><ProtectedRoute requiredRoles={['org:admin', 'org:owner', 'superadmin']}><PrinterDetail /></ProtectedRoute></RouteErrorBoundary>} />
          <Route path="/gallery/datasets" element={<RouteErrorBoundary><ProtectedRoute requiredRoles={['org:admin', 'org:owner', 'superadmin']}><GalleryDataSetsList /></ProtectedRoute></RouteErrorBoundary>} />
          {/* Explicitly approved restoration: /game -> existing GameList; not a proven historical React registration. */}
          <Route path="/game" element={<RouteErrorBoundary><GameRoute><GameList /></GameRoute></RouteErrorBoundary>} />
          <Route path="/game/edit/:id" element={<RouteErrorBoundary><GameRoute><GameSetup /></GameRoute></RouteErrorBoundary>} />
          <Route path="/game/board/:id" element={<RouteErrorBoundary><GameRoute><GameBoard /></GameRoute></RouteErrorBoundary>} />
          <Route path="/gallery/display/:id" element={<RouteErrorBoundary><ProtectedRoute requiredRoles={['org:admin', 'org:owner', 'superadmin']}><DisplayGallery /></ProtectedRoute></RouteErrorBoundary>} />
          <Route path="/gallery/setup/:id" element={<RouteErrorBoundary><ProtectedRoute requiredRoles={['org:admin', 'org:owner', 'superadmin']}><GallerySetup /></ProtectedRoute></RouteErrorBoundary>} />
          <Route path="/actions/bydataset/view/:datasetId" element={<RouteErrorBoundary><ProtectedRoute requiredRoles={['org:owner','org:admin','superadmin']}><DataSetActionsView /></ProtectedRoute></RouteErrorBoundary>} />
          <Route path="/actions/bydataset/edit/:datasetId" element={<RouteErrorBoundary><ProtectedRoute requiredRoles={['org:owner','org:admin','superadmin']}><DataSetActionsEdit /></ProtectedRoute></RouteErrorBoundary>} />
          <Route path="/actions/add" element={<RouteErrorBoundary><ProtectedRoute requiredRoles={['org:owner','org:admin','superadmin']}><AddAction /></ProtectedRoute></RouteErrorBoundary>} />
          <Route path="/actions" element={<RouteErrorBoundary><ProtectedRoute requiredRoles={['org:owner','org:admin','superadmin']}><ActionsList /></ProtectedRoute></RouteErrorBoundary>} />
          <Route path="/actions/edit/:id" element={<RouteErrorBoundary><ProtectedRoute requiredRoles={['org:owner','org:admin','superadmin']}><EditAction /></ProtectedRoute></RouteErrorBoundary>} />
          <Route path="/partners/portal" element={<RouteErrorBoundary><ProtectedRoute requiredRoles={['org:admin', 'org:owner', 'superadmin']}><PartnerPortal /></ProtectedRoute></RouteErrorBoundary>} />
      </Routes>
    );
}
